import { render, staticRenderFns } from "./quantityBg.vue?vue&type=template&id=623b3d68&lang=pug&"
import script from "./quantityBg.vue?vue&type=script&setup=true&lang=js&"
export * from "./quantityBg.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports